//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomerNameInput',
  props: {
    roomIndex: {
      type: Number | String,
      default: 1,
    },
    nameIndex: {
      type: Number | String,
      default: 1,
    },
    defaultName: {
      type: Object,
      default: null
    },
  },
  data(){
    return {
      firstName: '',
      lastName: '',
      firstHover: false,    // 姓氏拼音输入框是否获得焦点
      lastHover: false,     // 名字输入框是否获得焦点
    };
  },
  watch: {
    defaultName(curObj){
      if(curObj){
        this.firstName = curObj.first_name;
        this.lastName = curObj.last_name;
      }
    },
  },
  methods: {
    getCustomData(){
      if(this.firstName && this.lastName){
        return {room_id: this.roomIndex, first_name: this.firstName, last_name: this.lastName};
      }
      return null;
    },

    onFocus(iptType){
      if(iptType === 'firstName'){
        this.firstHover = true;
      }else{
        this.lastHover = true;
      }
    },

    onBlur(iptType){
      if(iptType === 'firstName'){
        this.firstHover = false;
      }else{
        this.lastHover = false;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/CustomerNameInput.vue